import type { Ga4TrafficPathReq, Ga4TrafficPathResp } from './ga4TrafficPath.types';
import { httpClient, baseUrl, getAuthHeaders } from 'src/pages/admin/providers/AppDataProvider';

function buildQuery(params: Record<string, any>) {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '') return;
        sp.set(k, String(v));
    });
    return sp.toString();
}

export async function getGa4TrafficPath(params: Ga4TrafficPathReq): Promise<Ga4TrafficPathResp> {
    const qs = buildQuery({
        from: params.from,
        to: params.to,
        timezone: params.timezone,
        path: params.path,
        pathMatch: params.pathMatch ?? 'PREFIX',
    });

    const url = `${baseUrl}/ga4/traffic/path?${qs}`;
    const headers = new Headers({
        Accept: 'application/json',
        ...(await getAuthHeaders()),
    });

    try {
        const { json } = await httpClient(url, { method: 'GET', headers });
        return json as Ga4TrafficPathResp;
    } catch (e: any) {
        // 兼容 fetchJson 抛出的 HttpError：e.body / e.message
        const msg =
            e?.body?.message ||
            e?.message ||
            'GA4 traffic path request failed';
        throw new Error(msg);
    }
}